import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HeaderActionsService } from './header-actions-service';
import { HeaderAction } from '../header/header.component';
import { User } from '@data/models/user.model';


@Component({
    selector: 'syn-layout-detail',
    templateUrl: './layout-detail.component.html',
    styleUrls: ['./layout-detail.component.scss'],
})
export class LayoutDetailComponent implements OnInit {

    @Input() navigations: LayoutDetailNavigation[] = [];

    @Input() headerText: string;
    @Input() headerCaption: string;
    @Input() headerTooltip: string;
    @Input() headerIcon: string;
    @Input() user: User;

    public actions$: Observable<HeaderAction[]>;
    public menuActions$: Observable<HeaderAction[]>;

    constructor(
        private readonly headerActionsService: HeaderActionsService,
        private readonly route: ActivatedRoute,
    ) { }

    public ngOnInit(): void {
        this.actions$ = this.headerActionsService.getHeaderActionObservable();
        this.menuActions$ = this.headerActionsService.getMenuActionObservable();
    }

    public isActiveChildRoute({ fragment }: { text: string; fragment: string }): boolean {
        return this.route.snapshot.fragment === fragment;
    }
}

export interface LayoutDetailNavigation {
    text: string;
    icon: string;
    routerLink: string;
    fragment?: string;
    show?: boolean;
    status?: {
        text?: string;
        icon: string;
        color?: string;
    };
    children?: Array<{
        text: string;
        fragment: string;
    }>;
}
